import { Base64 } from 'js-base64';

export const NYL_REGISTRATION_PROFILE_KEY = 'NYL_REGISTRATION_PROFILE';

export const setRegistrationProfile = ({
  firstName,
  lastName,
  phone,
  birthdate,
}) => {
  const payload = {
    firstName,
    lastName,
    phone,
    birthdate,
  };
  try {
    sessionStorage.setItem(
      NYL_REGISTRATION_PROFILE_KEY,
      Base64.encode(JSON.stringify(payload)),
    );
  } catch (e) {
    // sessionStorage unavailable
  }
};

export const getRegistrationProfile = () => {
  try {
    const raw = sessionStorage.getItem(NYL_REGISTRATION_PROFILE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(Base64.decode(raw));
    if (!parsed || typeof parsed !== 'object') {
      return null;
    }
    return parsed;
  } catch (e) {
    return null;
  }
};

export const clearRegistrationProfile = () => {
  try {
    sessionStorage.removeItem(NYL_REGISTRATION_PROFILE_KEY);
  } catch (e) {
    // sessionStorage unavailable
  }
};
